
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnBOMGrid extends Serenity.EntityGrid<ApprovalOutReturnBOMRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutReturnBOM'; }
        protected getDialogType() { return ApprovalOutReturnBOMDialog; }
        protected getIdProperty() { return ApprovalOutReturnBOMRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutReturnBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutReturnBOMRow.localTextPrefix; }
        protected getService() { return ApprovalOutReturnBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}